import { Icon, type IconGlyphProps } from 'BomdisoftComponents/icons/base';
import { CHECK_CIRCLE_OUTLINE_OUTLINED_GLYPH } from 'BomdisoftComponents/icons/glyphs';

export const CheckCircleOutlineOutlinedIcon = (props: IconGlyphProps) => <Icon {...props} glyph={CHECK_CIRCLE_OUTLINE_OUTLINED_GLYPH} />;
